// Interpreting DELETE /auth/me failures.
//
// The api client retries 5xx/network failures, so when a deletion
// succeeds server-side but the response is lost (Render cold start,
// webview socket drop on backgrounding), the retry replays the DELETE
// against an account that no longer exists:
//
//   • 401 — the Supabase identity is gone, so the JWT no longer
//     resolves. (Also fires if the session simply expired — in which
//     case logging the user out is the correct UX anyway; the global
//     401 handler is already navigating to /login.)
//   • 404 — pre-idempotency backends answered this when the users row
//     was already deleted; current backend returns 200.
//
// Both mean "stop showing an error toast over an account that is
// gone" — the caller should proceed to logout, not display a retry
// prompt the user can't act on.
export function deletionCompletedDespiteError(err) {
  return err?.status === 401 || err?.status === 404;
}
